import FieldTags from "../../../generic/tags/tags"
import FieldConfig from "../../../proto/field-config"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import {LifecycleAction} from "../../../../gd/const/lifecycle"
import Task from "../../../../model2/task/task"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldTaskTags extends FieldTags {

    constructor(config:FieldConfig) {
        super(config)

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(task: Task): boolean {
        return task.acl.canChangeTags
    }

    tableCellOnValueChange = (item: ItemModelV2, value: any, manager: TasksViewManager) => {
        // @ts-ignore
        item.task[this.fieldId] = value
        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render
        FieldProto_updateView(manager as TasksViewManager, this)
    }
}
